import React from "react";
import { createPortal } from "react-dom";

const Modal = ({ isOpen, children }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="modal-backdrop fixed inset-0 z-50 flex flex-col w-full h-full items-center justify-center p-[10px] gap-[10px] bg-modal">
      {children}
    </div>,
    document.getElementById("portal")
  );
};

export default Modal;
